// Importaciones necesarias para el componente
import Slider from 'react-slick'; // Importa el componente Slider de react-slick para el carrusel
import "slick-carousel/slick/slick.css"; // Importa los estilos CSS para el carrusel
import "slick-carousel/slick/slick-theme.css"; // Importa el tema de estilos CSS para el carrusel
import { FaConciergeBell, FaSun, FaLeaf, FaGlassCheers } from 'react-icons/fa'; // Importa íconos de FontAwesome
import { BsFillGiftFill } from 'react-icons/bs'; // Importa un ícono de Bootstrap
import { useNavigate } from 'react-router-dom'; // Hook para la navegación en React Router//
import '../../styles/general/carrucelServices.css'; // Importa los estilos CSS personalizados para el carrusel

// Configuración del carrusel
const settings = {
  dots: false, // Desactiva los puntos de navegación
  infinite: true, // Habilita el deslizamiento infinito
  speed: 500, // Velocidad de la animación en milisegundos
  slidesToShow: 4, // Número de diapositivas a mostrar simultáneamente
  slidesToScroll: 1, // Número de diapositivas a desplazar al hacer clic en las flechas
  arrows: true, // Habilita las flechas de navegación
  centerMode: false, // Modo centrado desactivado
  initialSlide: 0, // Comienza en la primera diapositiva

  // Configuración para diferentes tamaños de pantalla (responsive design)
  responsive: [
    {
      breakpoint: 1024, // Ancho máximo de pantalla para aplicar esta configuración
      settings: {
        slidesToShow: 3, // Muestra 3 diapositivas a la vez
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600, // Ancho máximo de pantalla para esta configuración
      settings: {
        slidesToShow: 3, // Muestra 3 diapositivas a la vez
        slidesToScroll: 1,
        initialSlide: 2 // Comienza en la tercera diapositiva
      }
    },
    {
      breakpoint: 480, // Ancho máximo de pantalla para esta configuración
      settings: {
        slidesToShow: 1, // Muestra 1 diapositiva a la vez
        slidesToScroll: 1
      }
    }
  ]
};

// Mapeo de iconos para simplificar la comparación
const iconMapping = {
  FaLeaf: FaLeaf,
  BsFillGiftFill: BsFillGiftFill,
  FaGlassCheers: FaGlassCheers,
  FaConciergeBell: FaConciergeBell,
  FaSun: FaSun,
};

// Componente CarruselServices
export const CarruselServices = ({ services }) => {  // Recibe 'services' como prop=
  const navigate = useNavigate(); // Hook para navegar a diferentes rutas

  // Maneja la navegación cuando un usuario hace clic al componente EventosPrincipal
  const handleNavigation = (name) => {
    navigate(`/espacios-para-tu-evento/${name}`, { state: { scrollToTop: true } }); // Navega a la ruta especificada y desplaza la página al inicio
  };


  return (
    <div>
      <section className="carousel-container">
        <Slider {...settings}>
          {services.map((service) => {
            const IconComponent = iconMapping[service.icono]; // Obtén el componente de ícono

            return (
              <div key={service.id} className="feature" onClick={() => handleNavigation(service.name.toLowerCase())}>
                <div className="icon-container">
                  {IconComponent && <IconComponent className={`fa-icon home-icon-${service.name.toLowerCase()}`} />} {/* Renderiza el ícono dinámicamente */}
                </div>
                <h2 className="title">{service.name}</h2> {/* Muestra el nombre del servicio */}
              </div>
            );
          })}
        </Slider>
        <p>Donde cada evento es una celebración</p> {/* Texto adicional debajo del carrusel */}
      </section>
    </div>
  );
};
